import React, { useCallback, useEffect, useState } from "react";
import { Table } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { viewExperienceCenterFormList } from "../../Redux/Actions/experienceCenterActions";
import "./listUserRequest.css";
import toast from "react-hot-toast";
import { columnsExperienceCenterForm } from "../../Global Functions/columnsAntd";
import DateRangePopup from "../../Utils/dateFilterPopup";
import ListTopSearch from "../../Global Functions/listTopSearch";

const ListExperienceCenterForm = () => {
    const dispatch = useDispatch();
    const [searchQuery, setSearchQuery] = useState("");
    const [dateRange, setDateRange] = useState({ start: null, end: null });
    const [debouncedSearch, setDebouncedSearch] = useState(searchQuery);
    const [isDatePopupVisible, setIsDatePopupVisible] = useState(false);

    const { admin } = useSelector((state) => state.admin || {});
    const accessCode = admin?.data?.access_code || [];
    const canEdit = Array.isArray(accessCode) && accessCode.includes("edit");

    const [pagination, setPagination] = useState({
        current: 1,
        pageSize: 10,
        total: 0,
        showSizeChanger: true,
        pageSizeOptions: ["5", "10", "20", "50", "100"],
    });

    const fetchDetails = useCallback(
        async (page, pageSize, showLoader = true) => {
            const payload = {
                page,
                limit: pageSize,
                is_deleted: false,
                filter: debouncedSearch,
                ...(dateRange.start && { start_date: dateRange.start.format("YYYY-MM-DD") }),
                ...(dateRange.end && { end_date: dateRange.end.format("YYYY-MM-DD") }),
            };

            try {
                await dispatch(viewExperienceCenterFormList(payload, showLoader));
                if (!showLoader) toast.success("Experience center form list refreshed");
            } catch {
                if (!showLoader) toast.error("Failed to refresh list");
            }
        },
        [dispatch, debouncedSearch, dateRange]
    );

    useEffect(() => {
        fetchDetails(pagination.current, pagination.pageSize);
    }, [fetchDetails, pagination.current, pagination.pageSize]);

    const { experienceCenterForms, loading } = useSelector((state) => state.experienceCenter || {});

    useEffect(() => {
        if (experienceCenterForms?.total) {
            setPagination((prev) => ({ ...prev, total: experienceCenterForms.total }));
        }
    }, [experienceCenterForms]);

    useEffect(() => {
        const handler = setTimeout(() => {
            setDebouncedSearch(searchQuery);
        }, 500);
        return () => clearTimeout(handler);
    }, [searchQuery]);

    const handleTableChange = (pagination) => {
        setPagination(pagination);
    };

    const handleDateRangeApply = (start, end) => {
        if (start === null && end === null) {
            setDateRange({ start: null, end: null });
        } else {
            setDateRange({ start, end });
        }
        setIsDatePopupVisible(false);
        setPagination((prev) => ({ ...prev, current: 1 }));
    };

    return (
        <>
            <div className="lec-container">
                <div className="lec-table-wrap">
                    <ListTopSearch
                        h3heading="Experience Center Form List"
                        setState={setSearchQuery}
                        onCalendarClick={() => setIsDatePopupVisible(true)}
                    />
                    <div style={{ overflowX: "auto", padding: "0px 60px" }}>
                        <Table
                            dataSource={Array.isArray(experienceCenterForms?.data) ? experienceCenterForms.data : []}
                            pagination={pagination}
                            scroll={{ x: 1400, y: 500 }}
                            onChange={handleTableChange}
                            loading={loading}
                            columns={columnsExperienceCenterForm(canEdit)}
                            rowKey="_id"
                            rowClassName={() => "text-center"}
                        />
                    </div>
                </div>
                <DateRangePopup
                    visible={isDatePopupVisible}
                    initialStart={dateRange.start}
                    initialEnd={dateRange.end}
                    onCancel={() => setIsDatePopupVisible(false)}
                    onOk={handleDateRangeApply}
                />
            </div>
        </>
    );
};

export default ListExperienceCenterForm;